import push from '../../utils/routing';

export default (spaceId, assignmentId) => () =>
  push(`/dashboard/${spaceId}/journey/assignments/${assignmentId}/submissions`);
